export default __webpack_public_path__ + "static/media/Group_7475.98b9c4be.png";